import { useEffect, useRef } from 'react';

function Shop({ url, onSuccess, onClose }) {
	const iframeRef = useRef(null);

	useEffect(() => {
		const handleMessage = (event) => {
			// optional: check origin
			if (event.data?.type === 'SEND_DATA') {
				onSuccess?.(event.data.payload);
			}
		};

		window.addEventListener('message', handleMessage);
		return () => window.removeEventListener('message', handleMessage);
	}, [onSuccess]);

	const handleLoad = () => {
		try {
			const href = iframeRef.current?.contentWindow?.location?.href;
			if (!href) return;

			const url = new URL(href);
			const allow = url.searchParams.get('allow');
			const code = url.searchParams.get('code');

			if (allow === 'true') {
				// Gửi message cho parent (HomeNew)
				window.postMessage(
					{
						type: 'SEND_DATA',
						payload: { code, allow: true }
					},
					'*'
				);
			}
		} catch (e) {
			// cross-domain thì bỏ qua, chờ postMessage từ backend page
		}
	};

	return (
		<iframe
			ref={iframeRef}
			className="shop-page-new-content-iframe"
			src={url}
			// src={'http://localhost:3001/?allow=true&code=123456'}
			allow="fullscreen"
			onLoad={handleLoad}
		/>
	);
}

export default Shop;